import {Component, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../modules/modal/modal-ref";
import * as fromStore from '../../../../store';
import {filter, first} from "rxjs/operators";
import {WebsiteService} from "../../../../websites/website.service";
import {Store} from "@ngrx/store";
import {DbStoreState, getUserLocalStorage} from "../../../../store";
import {Router} from "@angular/router";
import {NotifierComponent} from "../../notifier/notifier.component";
import {Notification} from "../../notifier/notification";
import {NotificationType} from "../../notifier/notification-type";
import {UserService} from "../../../../user/user.service";

@Component({
    selector: 'db-remove-demo',
    templateUrl: './remove-demo.component.html',
    styleUrls: ['./remove-demo.component.scss'],
    standalone: false
})
export class RemoveDemoComponent implements OnInit {

  public loading: boolean;
  private _userLocalStorage: any;

  constructor(
    private _store: Store<DbStoreState>,
    private _activeModal: DbActiveModal,
    private _router: Router,
    private _userService: UserService,
    private _websiteService: WebsiteService
  ) { }

  ngOnInit() {
    this._getLocalStorage();
  }

  private _getLocalStorage(): void {
    this._store.select(getUserLocalStorage)
      .pipe(
        filter(userLocalStorage => !!userLocalStorage),
        first()
      )
      .subscribe(userLocalStorage => {
        this._userLocalStorage = userLocalStorage;
      });
  }

  private _changeLocalStorageData(): void {
    this._userLocalStorage['onboardingFinished'] = false;
    this._userService.setToLocal(this._userLocalStorage)
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
        }
      });
  }

  close(): void {
    this._activeModal.close();
  }

  public removeDemoWebsiteRequest(): void {
    this.loading = true;
    this._websiteService.removeDemoWebsite()
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        if (response.success) {
          this._changeLocalStorageData();
          this._store.dispatch(new fromStore.LoadUserSubscription());
          this._router.navigate(['/upgrade-plan']);
          this.close();
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.loading = false;
      });
  }

}
